// extracted by mini-css-extract-plugin
module.exports = {"collapsableMenu":"_2XJ31","scrollIndicator":"_3wSXt","blinker":"_1rTpb","scrollVisible":"_2b9tQ","rightOriented":"_3lhH_"};